import { ExistingSubscription, Subscription } from "../model/model";
import { ISubscriptionService } from "./ISubscriptionService";

/**
 * Implements ISubscriptionService for managing subscriptions to our App
 */
export class SubscriptionService implements ISubscriptionService {
  private backendUrl: string;

  private resolveSubscriptionUrl: string;
  private activateSubscriptionUrl: string;
  private getExistingSubscriptionUrl: string;
  private removeUserFromSubscriptionUrl: string;

  constructor() {
    this.backendUrl = process.env.BACKEND_URL ?? '';
    this.resolveSubscriptionUrl = `${this.backendUrl}/landing/resolve`;
    this.activateSubscriptionUrl = `${this.backendUrl}/landing/activate`;
    this.getExistingSubscriptionUrl = `${this.backendUrl}/subscription/status`;
    this.removeUserFromSubscriptionUrl = `${this.backendUrl}/subscription/users`;
  }

  async resolveSubscription(marketplaceToken: string, accessToken: string): Promise<Subscription> {
    //await new Promise((r) => setTimeout(() => r({}), 3000));

    const resp = await fetch(
      this.resolveSubscriptionUrl,
      {
        method: 'POST',
        headers: {
          'ContentType': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
          marketplaceToken
        })
      }
    );

    if (resp.ok) {
      return await resp.json();
    }

    return Promise.reject(`HTTP ${resp.status} ${resp.statusText}\n${await resp.text()}`);
  }

  async activateSubscription(
    tenantId: string,
    subscriptionId: string,
    planId: string,
    isTrial: boolean,
    maxUsersAllowed: number,
    accessToken: string): Promise<void> {
    // await new Promise((r) => setTimeout(() => r({}), 3000));

    const resp = await fetch(
      this.activateSubscriptionUrl,
      {
        method: 'POST',
        headers: {
          'ContentType': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
          tenantId,
          subscriptionId,
          planId,
          isTrial,
          maxUsersAllowed
        })
      }
    );

    if (resp.ok) {
      return;
    }

    return Promise.reject(`HTTP ${resp.status} ${resp.statusText}\n${await resp.text()}`);
  }

  async getExistingSubscription(tenantId: string, accessToken: string): Promise<ExistingSubscription> {
    //await new Promise((r) => setTimeout(() => r({}), 3000));

    const resp = await fetch(
      this.getExistingSubscriptionUrl,
      {
        method: 'POST',
       headers: {
          'ContentType': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
          tenantId
        })
      }
    );

    if (resp.ok) {
      return await resp.json();
    }

    return Promise.reject(`HTTP ${resp.status} ${resp.statusText}\n${await resp.text()}`);
  }

  async removeUser(subscriptionId: string, tenantId: string, userId: string, accessToken: string): Promise<void> {
    //await new Promise((r) => setTimeout(() => r({}), 3000));

    const resp = await fetch(
      this.removeUserFromSubscriptionUrl,
      {
        method: 'DELETE',
        headers: {
          'ContentType': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
          subscriptionId,
          tenantId,
          userId
        })
      }
    );

    if (resp.ok) {
      return await resp.json();
    }

    return Promise.reject(`HTTP ${resp.status} ${resp.statusText}\n${await resp.text()}`);
  }
}